/* Ящик корзины (hg-cart-drawer). Вынесен из snippets/hg-cart-drawer.liquid
   09.09.2026: инлайном он занимал 42 860 байт в КАЖДОЙ странице — почти
   половину всего инлайн-JS темы, — и заново качался при каждом переходе.
   Внешний файл кешируется браузером один раз на весь сайт.

   Подключён с defer. Проверено перед выносом, что это безопасно:
   файл ПРИСВАИВАЕТ ровно четыре глобала — window.hgUpdateDrawer,
   window.hgOpenDrawer, window.hgShowAddingPlaceholder и
   window.hgHideAddingPlaceholder (последние два — 2026-09-15, чтобы rxapp
   мог показать тот же плейсхолдер при своём fetch('/cart/add.js')), —
   и больше их не присваивает никто. Имена
   hgUpdateCart и wishlistAddItem он только ЗОВЁТ, всегда через
   typeof === 'function', а определяют их main-cart-items.liquid и
   wishlist-drawer.liquid. То есть порядок выполнения ничью версию не
   перетирает.

   (В первой редакции здесь стояло обратное — «без defer, иначе перетрёт».
   Вывод был сделан по grep'у "window\.[A-Za-z_]*\s*=", который считал
   присваиванием и сравнение `window.hgUpdateCart == "function"`. Строгая
   проверка версию сняла.) */
(function () {
  var drawer = document.getElementById('hg-cart-drawer');
  if (!drawer) return;

  var FREE_SHIPPING = parseInt(drawer.dataset.freeShipping || '9900', 10);
  var MSG_SUCCESS = drawer.dataset.freeShippingSuccess || 'Your order is eligible for free shipping!';
  var MSG_PROGRESS_TPL = drawer.dataset.freeShippingProgress || 'Spend {amount} more for free shipping!';
  /* Единственное, что этот файл берёт из Liquid. Раньше значение печаталось
     сюда прямо из шаблона, из-за чего весь скрипт был обязан жить инлайном.
     Теперь оно приезжает data-атрибутом, как и остальные настройки выше. */
  var PRELOAD_PRODUCT_ID = Number(drawer.dataset.preloadProductId || 0) || null;
  /* /cart.js prices already in cart's market currency (Shopify Markets) — don't apply rate */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function imgUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  function escHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function escAttr(s) { return String(s || '').replace(/"/g, '&quot;'); }

  /* --- Header height (same as wishlist-drawer) --- */
  function updateHeaderHeight() {
    var h = (document.querySelector('.section-header') || { offsetHeight: 0 }).offsetHeight;
    drawer.style.setProperty('--hg-cart-header-height', h + 'px');
  }

  /* --- Klaviyo banner hide/show --- */
  function setKlTeaserVisibility(visible) {
    document.querySelectorAll('[class*="kl-teaser-"]').forEach(function (el) {
      el.style.visibility = visible ? '' : 'hidden';
      el.style.opacity    = visible ? '' : '0';
    });
  }

  /* --- Open / Close --- */
  function showDrawer() {
    updateHeaderHeight();
    setKlTeaserVisibility(false);
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function open() {
    showDrawer(); /* instant — content pre-rendered by Liquid, recs pre-loaded */
  }

  function close() {
    var rxRating = drawer.querySelector('.hg-cart-drawer__checkout-wrap .hgGr--cart');
    if (rxRating) rxRating.hidden = false;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setKlTeaserVisibility(true);
  }

  /* --- Cart API --- */
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function changeQty(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) return Promise.reject(data);
        return data;
      });
    });
  }

  function addItem(formData) {
    return fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); });
  }

  /* --- Shipping bar --- */
  function updateShipping(total) {
    var textEl = document.getElementById('hg-shipping-text');
    var fillEl = document.getElementById('hg-shipping-fill');
    if (!textEl || !fillEl) return;
    if (total >= FREE_SHIPPING) {
      textEl.textContent = MSG_SUCCESS;
      fillEl.style.width = '100%';
      fillEl.style.background = 'chartreuse';
      fillEl.classList.add('hg-cart-drawer__shipping-fill--full');
    } else {
      textEl.textContent = MSG_PROGRESS_TPL.replace('{amount}', formatMoney(FREE_SHIPPING - total));
      fillEl.style.width = Math.round((total / FREE_SHIPPING) * 100) + '%';
      fillEl.style.background = '#00bb00';
      fillEl.classList.remove('hg-cart-drawer__shipping-fill--full');
    }
  }

  /* --- Cart count badge --- */
  function updateBadge(count) {
    /* Dawn cart-count-bubble */
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (bubble) {
      var num = bubble.querySelector('[aria-hidden="true"]');
      if (num) num.textContent = count;
      bubble.style.display = count > 0 ? '' : 'none';
    }
    /* Custom .cart-count span — create dynamically if missing (page loaded with empty cart) */
    document.querySelectorAll('a[href="/cart"]').forEach(function(link) {
      if (link.closest('#hg-cart-drawer')) return;
      var span = link.querySelector('.cart-count');
      if (!span) {
        span = document.createElement('span');
        span.className = 'cart-count';
        link.appendChild(span);
      }
      span.textContent = count;
      span.style.display = count > 0 ? '' : 'none';
    });
  }

  /* --- Render cart --- */
  function render(cart) {
    var totalEl = document.getElementById('hg-cart-total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    updateShipping(cart.total_price);
    updateBadge(cart.item_count);

    var el = document.getElementById('hg-cart-items');
    if (!el) return;

    var isEmpty = cart.item_count === 0;
    var footerNote = drawer.querySelector('.hg-cart-drawer__footer-note');
    var checkoutWrap = drawer.querySelector('.hg-cart-drawer__checkout-wrap');
    var shippingBar = document.getElementById('hg-shipping-bar');
    var viewCart = drawer.querySelector('.hg-cart-drawer__view-cart');
    if (footerNote) footerNote.style.display = isEmpty ? 'none' : '';
    if (checkoutWrap) checkoutWrap.style.display = isEmpty ? 'none' : '';
    if (shippingBar) shippingBar.style.display = isEmpty ? 'none' : '';
    if (viewCart) viewCart.style.display = isEmpty ? 'none' : '';
    /* No "30-day returns" next to the Google rating while the cart holds an Rx line (snippets/hg-google-rating.liquid) */
    var hasRx = (cart.items || []).some(function (i) { return i.properties && i.properties.Prescription; });
    drawer.querySelectorAll('.hgGr__ret').forEach(function (s) { s.hidden = hasRx; });

    if (isEmpty) {
      el.innerHTML = '<div class="hg-cart-empty"><p>Your cart is empty</p><a href="/" class="hg-cart-browse-btn">Browse products</a></div>';
      var recsEl = document.getElementById('hg-cart-recs');
      if (recsEl) recsEl.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function (item, i) {
      if (item.quantity === 0) return; /* skip phantom zero-qty items from /cart/change.js response */
      /* skip transient row: item added but Shopify storefront read hasn't
         caught up yet — product_id null and price 0 means it'll self-correct
         on the next render(), not a real free item. */
      if (item.product_id == null && item.price === 0) return;
      var line = i + 1;
      var img = item.image ? imgUrl(item.image, 176) : '';

      /* variant options */
      var opts = '';
      if (item.options_with_values && item.options_with_values.length) {
        item.options_with_values.forEach(function (o) {
          if (o.value && o.value !== 'Default Title') {
            opts += '<div class="hg-cart-item__option"><span class="hg-cart-item__opt-name">' + escHtml(o.name) + ':</span> ' + escHtml(o.value) + '</div>';
          }
        });
      } else if (item.variant_title && item.variant_title !== 'Default Title') {
        opts = '<div class="hg-cart-item__option">' + escHtml(item.variant_title) + '</div>';
      }

      html += '<div class="hg-cart-item" data-line="' + line + '">';
      if (img) {
        html += '<a href="' + item.url + '" class="hg-cart-item__image-wrap">';
        html += '<img class="hg-cart-item__image" src="' + img + '" alt="' + escAttr(item.product_title || item.title) + '" width="88" height="72" loading="lazy">';
        html += '</a>';
      }
      html += '<div class="hg-cart-item__details">';
      html += '<div class="hg-cart-item__top-row">';
      html += '<div class="hg-cart-item__info">';
      html += '<a href="' + item.url + '" class="hg-cart-item__name">' + escHtml(item.product_title || item.title) + '</a>';
      html += '</div>';
      html += '<div class="hg-cart-item__price">' + formatMoney(item.final_line_price) + '</div>';
      html += '</div>'; /* top-row */
      if (opts) html += '<div class="hg-cart-item__options">' + opts + '</div>';
      html += '<div class="hg-cart-item__qty-row">';
      html += '<div class="hg-cart-item__qty">';
      html += '<button class="hg-qty-btn hg-qty-minus" data-line="' + line + '" aria-label="Decrease quantity">\u2212</button>';
      html += '<span class="hg-qty-val">' + item.quantity + '</span>';
      html += '<button class="hg-qty-btn hg-qty-plus" data-line="' + line + '" aria-label="Increase quantity">+</button>';
      html += '</div>';
      html += '<button class="hg-cart-item__remove" data-line="' + line + '" aria-label="Remove item">';
      html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg>';
      html += '</button>';
      var wlImg = item.image ? imgUrl(item.image, 400) : '';
      html += '<button class="hg-cart-item__wishlist" data-line="' + line + '"'
        + ' data-product-id="' + escAttr(String(item.product_id)) + '"'
        + ' data-product-url="' + escAttr(item.url) + '"'
        + ' data-product-title="' + escAttr(item.product_title || item.title) + '"'
        + ' data-product-image="' + escAttr(wlImg) + '"'
        + ' data-product-price="' + escAttr(formatMoney(item.final_price)) + '"'
        + ' aria-label="Move to wishlist">';
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      html += 'Move to wishlist</button>';
      html += '</div>'; /* qty-row */
      html += '</div>'; /* details */
      html += '</div>'; /* item */
    });

    el.innerHTML = html;

    /* recommendations */
    /* anchor on the frame, not on the rxapp service line (prescription-order*) */
    var recAnchor = cart.items.filter(function (it) { return !/^prescription-order/.test(it.handle || ''); })[0] || cart.items[0];
    if (recAnchor) loadRecs(recAnchor.product_id);
  }

  function fetchAndRender() {
    return fetchCart().then(render);
  }

  /* Expose for cart page to trigger drawer refresh.
     Accepts optional cart object — avoids redundant /cart.js fetch. */
  window.hgUpdateDrawer = function (cart) {
    if (cart && typeof cart === 'object' && cart.items) return render(cart);
    return fetchAndRender();
  };
  window.hgOpenDrawer = showDrawer;

  /* Exposed for apps (rxapp) that add to cart via their own fetch('/cart/add.js')
     and want to show the same "Adding to cart..." placeholder we use. */
  window.hgShowAddingPlaceholder = showAddingPlaceholder;
  window.hgHideAddingPlaceholder = hideAddingPlaceholder;

  /* --- Recommendations --- */
  function loadRecs(productId) {
    var recsEl = document.getElementById('hg-cart-recs');
    var listEl = document.getElementById('hg-recs-list');
    if (!recsEl || !listEl || !productId) return;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        /* $0 service products (Prescription Order*, own-frame Rx) are not something to upsell */
        var prods = ((data && data.products) || []).filter(function (p) {
          return p.price_min > 0 && (p.tags || []).indexOf('RxApp') === -1;
        }).slice(0, 6);
        if (!prods.length) { recsEl.style.display = 'none'; return; }
        recsEl.style.display = '';

        /* Store product data for options popup */
        var recProducts = {};

        var html = '';
        prods.forEach(function (p) {
          var imgSrc = '';
          if (p.featured_image) {
            imgSrc = typeof p.featured_image === 'string'
              ? imgUrl(p.featured_image, 260)
              : (p.featured_image.src ? imgUrl(p.featured_image.src, 260) : '');
          }
          if (!imgSrc && p.images && p.images.length) {
            var fi = p.images[0];
            imgSrc = typeof fi === 'string' ? imgUrl(fi, 260) : (fi && fi.src ? imgUrl(fi.src, 260) : '');
          }
          var price = formatMoney(p.price_min);
          /* detect if product needs option selection:
             true only when at least one option has >1 unique value among available variants */
          var _avail = (p.variants || []).filter(function(v) { return v.available; });
          if (!_avail.length) _avail = p.variants || [];
          var needsOptions = false;
          if (_avail.length > 1 || (_avail.length === 1 && _avail[0].title && _avail[0].title !== 'Default Title')) {
            var numOpts = p.options ? p.options.length : (_avail[0] && _avail[0].options ? _avail[0].options.length : 0);
            for (var _oi = 1; _oi <= numOpts; _oi++) {
              var _vals = {};
              _avail.forEach(function(v) { if (v['option' + _oi]) _vals[v['option' + _oi]] = 1; });
              if (Object.keys(_vals).length > 1) { needsOptions = true; break; }
            }
          }
          var _firstAvail = _avail[0] || (p.variants && p.variants[0]);
          var variantId = !needsOptions && _firstAvail ? _firstAvail.id : '';
          var pid = String(p.id);
          recProducts[pid] = p;

          html += '<div class="hg-rec-card">';
          if (imgSrc) html += '<a href="' + p.url + '"><img src="' + imgSrc + '" alt="' + escAttr(p.title) + '" loading="lazy"></a>';
          html += '<div class="hg-rec-card__info">';
          html += '<a href="' + p.url + '" class="hg-rec-card__name">' + escHtml(p.title) + '</a>';
          html += '<span class="hg-rec-card__price">' + price + '</span>';
          html += '</div>';
          if (needsOptions) {
            html += '<button class="hg-rec-card__add hg-rec-card__opts" data-pid="' + pid + '">Choose options</button>';
          } else if (variantId) {
            html += '<button class="hg-rec-card__add" data-variant="' + variantId + '">Add to cart</button>';
          }
          html += '</div>';
        });
        listEl.innerHTML = html;

        /* simple add-to-cart buttons */
        listEl.querySelectorAll('.hg-rec-card__add:not(.hg-rec-card__opts)').forEach(function (btn) {
          btn.addEventListener('click', function () {
            btn.disabled = true;
            var fd = new FormData();
            fd.append('id', btn.dataset.variant);
            fd.append('quantity', '1');
            addItem(fd)
              .then(fetchAndRender)
              .then(function () {
                btn.disabled = false;
                var bodyEl = document.querySelector('.hg-cart-drawer__body');
                if (bodyEl) bodyEl.scrollTo({ top: 0, behavior: 'smooth' });
                maybeUpdateCartPage();
              })
              .catch(function () { btn.disabled = false; });
          });
        });

        /* "Choose options" buttons → open popup */
        var optsOverlay = document.getElementById('hg-opts-overlay');
        var optsPopup   = document.getElementById('hg-opts-popup');
        var optsTitle   = document.getElementById('hg-opts-title');
        var optsBody    = document.getElementById('hg-opts-body');
        var optsAdd     = document.getElementById('hg-opts-add');
        var optsClose   = document.getElementById('hg-opts-close');
        var currentOptsProduct = null;

        function closeOptsPopup() {
          if (optsOverlay) optsOverlay.classList.remove('open');
          if (optsPopup) { optsPopup.classList.remove('open'); optsPopup.setAttribute('aria-hidden', 'true'); }
        }

        /* read hidden selects in order → match variant */
        function getSelectedVariant() {
          if (!currentOptsProduct) return null;
          var selects = optsBody.querySelectorAll('.hg-opts-hidden-select');
          var chosen = Array.from(selects).map(function (s) { return s.value; });
          return currentOptsProduct.variants.find(function (v) {
            var opts = [v.option1, v.option2, v.option3].filter(Boolean);
            return opts.every(function (o, i) { return o === chosen[i]; });
          }) || null;
        }

        function updateOptsImg() {
          var variant = getSelectedVariant();
          var imgEl = document.getElementById('hg-opts-img');
          if (!imgEl) return;
          if (variant && variant.featured_image && variant.featured_image.src) {
            imgEl.src = imgUrl(variant.featured_image.src, 300);
          }
        }

        function canOrderVariant(v) {
          return v.available || (v.inventory_quantity != null && v.inventory_quantity > 0);
        }

        /* Cascading swatch availability: option[i] filtered by current selection of options[0..i-1] */
        function updateSwatchAvailability() {
          if (!currentOptsProduct) return;
          var selectedValues = {};
          optsBody.querySelectorAll('.hg-opts-hidden-select').forEach(function (s) {
            selectedValues[parseInt(s.dataset.optIdx, 10)] = s.value;
          });
          var maxIdx = 0;
          optsBody.querySelectorAll('.hg-opts-hidden-select').forEach(function (s) {
            var i = parseInt(s.dataset.optIdx, 10);
            if (i > maxIdx) maxIdx = i;
          });
          for (var oi = 0; oi <= maxIdx; oi++) {
            optsBody.querySelectorAll('.hg-opts-swatch').forEach(function (swatch) {
              var sel = swatch.querySelector('.hg-opts-hidden-select');
              if (!sel) return;
              var optIdx = parseInt(sel.dataset.optIdx, 10);
              if (optIdx !== oi) return;
              var list = swatch.querySelector('.hg-opts-swatch__list');
              if (!list) return;
              list.querySelectorAll('.hg-opts-swatch__item').forEach(function (item) {
                var val = item.dataset.value;
                var avail = currentOptsProduct.variants.some(function (v) {
                  if (!canOrderVariant(v) || v['option' + (optIdx + 1)] !== val) return false;
                  for (var i = 0; i < optIdx; i++) {
                    if (i in selectedValues && v['option' + (i + 1)] !== selectedValues[i]) return false;
                  }
                  return true;
                });
                item.style.display = avail ? '' : 'none';
              });
              /* Auto-reselect if selected item is now hidden */
              var selItem = list.querySelector('.hg-opts-swatch__item--selected');
              if (selItem && selItem.style.display === 'none') {
                var firstVis = null;
                list.querySelectorAll('.hg-opts-swatch__item').forEach(function (li) { if (!firstVis && li.style.display !== 'none') firstVis = li; });
                if (firstVis) {
                  list.querySelectorAll('.hg-opts-swatch__item').forEach(function (li) {
                    li.classList.toggle('hg-opts-swatch__item--selected', li === firstVis);
                    li.setAttribute('aria-selected', String(li === firstVis));
                  });
                  sel.value = firstVis.dataset.value;
                  selectedValues[optIdx] = sel.value;
                  var trigImg = swatch.querySelector('.hg-opts-swatch__trigger-img');
                  var trigLbl = swatch.querySelector('.hg-opts-swatch__trigger-label');
                  var newImg = firstVis.querySelector('img');
                  if (trigImg && newImg) trigImg.src = newImg.src;
                  if (trigLbl) trigLbl.textContent = firstVis.dataset.value;
                }
              }
            });
          }
          /* Hide entire option group when <=1 option visible */
          optsBody.querySelectorAll('.hg-opts-group').forEach(function (group) {
            var btns = group.querySelectorAll('.hg-opts-swatch__item, .hg-opts-pill-btn');
            var visible = Array.from(btns).filter(function (b) { return b.style.display !== 'none'; }).length;
            group.style.display = visible <= 1 ? 'none' : '';
          });
        }

        /* Cascading pill availability: option[i] filtered by current selection of options[0..i-1] */
        function updatePillAvailability() {
          if (!currentOptsProduct) return;
          var numOptions = currentOptsProduct.options.length;
          var selectedValues = {};
          optsBody.querySelectorAll('.hg-opts-hidden-select').forEach(function (s) {
            var idx = parseInt(s.dataset.optIdx, 10);
            if (idx >= 0 && idx < numOptions) selectedValues[idx] = s.value;
          });
          for (var oi = 0; oi < numOptions; oi++) {
            optsBody.querySelectorAll('.hg-opts-pills').forEach(function (pills) {
              var sel = pills.querySelector('.hg-opts-hidden-select');
              if (!sel) return;
              var optIdx = parseInt(sel.dataset.optIdx, 10);
              if (optIdx !== oi) return;
              pills.querySelectorAll('.hg-opts-pill-btn').forEach(function (pill) {
                var isAvailable = currentOptsProduct.variants.some(function (v) {
                  if (!(v.available || (v.inventory_quantity != null && v.inventory_quantity > 0))) return false;
                  if (v['option' + (optIdx + 1)] !== pill.dataset.value) return false;
                  for (var i = 0; i < optIdx; i++) {
                    if (i in selectedValues && v['option' + (i + 1)] !== selectedValues[i]) return false;
                  }
                  return true;
                });
                pill.style.display = isAvailable ? '' : 'none';
              });
              /* if selected pill is now hidden — pick first visible */
              var selectedPill = pills.querySelector('.hg-opts-pill-btn--selected');
              if (selectedPill && selectedPill.style.display === 'none') {
                var firstVisible = null;
                pills.querySelectorAll('.hg-opts-pill-btn').forEach(function (p) {
                  if (!firstVisible && p.style.display !== 'none') firstVisible = p;
                });
                if (firstVisible) {
                  pills.querySelectorAll('.hg-opts-pill-btn').forEach(function (p) {
                    p.classList.toggle('hg-opts-pill-btn--selected', p === firstVisible);
                  });
                  sel.value = firstVisible.dataset.value;
                  selectedValues[optIdx] = firstVisible.dataset.value;
                }
              }
            });
          }
          /* Hide entire option group when <=1 option visible */
          optsBody.querySelectorAll('.hg-opts-group').forEach(function (group) {
            var btns = group.querySelectorAll('.hg-opts-swatch__item, .hg-opts-pill-btn');
            var visible = Array.from(btns).filter(function (b) { return b.style.display !== 'none'; }).length;
            group.style.display = visible <= 1 ? 'none' : '';
          });
        }

        listEl.querySelectorAll('.hg-rec-card__opts').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var pid = btn.dataset.pid;
            var prod = recProducts[pid];
            if (!prod) return;
            currentOptsProduct = prod;
            optsTitle.textContent = prod.title;

            /* initial image */
            var initImgSrc = '';
            if (prod.featured_image) {
              initImgSrc = typeof prod.featured_image === 'string'
                ? imgUrl(prod.featured_image, 300)
                : (prod.featured_image.src ? imgUrl(prod.featured_image.src, 300) : '');
            }

            /* build selects column */
            var selectsHtml = '';
            prod.options.forEach(function (opt, idx) {
              var name = typeof opt === 'string' ? opt : (opt.name || '');
              var values = (opt.values && opt.values.length) ? opt.values.slice() : [];
              if (!values.length) {
                prod.variants.forEach(function (v) {
                  var val = v['option' + (idx + 1)];
                  if (val && values.indexOf(val) === -1) values.push(val);
                });
              }

              /* always add hidden select to preserve option order for getSelectedVariant() */
              var hiddenSelect = '<select class="hg-opts-hidden-select" style="display:none" data-opt-idx="' + idx + '">';
              values.forEach(function (val, i) {
                hiddenSelect += '<option value="' + escAttr(val) + '"' + (i === 0 ? ' selected' : '') + '>' + escHtml(val) + '</option>';
              });
              hiddenSelect += '</select>';

              /* skip UI if only 1 value */
              if (values.length <= 1) {
                selectsHtml += hiddenSelect;
                return;
              }

              var nameLower = name.toLowerCase();
              var isColor = nameLower.indexOf('frame') !== -1 || nameLower.indexOf('lens') !== -1;

              selectsHtml += '<div class="hg-opts-group">';
              selectsHtml += '<label>' + escHtml(name) + '</label>';

              if (isColor) {
                /* build image swatch */
                var valueImgMap = {};
                values.forEach(function (val) {
                  var match = null;
                  for (var vi = 0; vi < prod.variants.length; vi++) {
                    if (prod.variants[vi]['option' + (idx + 1)] === val) { match = prod.variants[vi]; break; }
                  }
                  if (match && match.featured_image && match.featured_image.src) {
                    valueImgMap[val] = imgUrl(match.featured_image.src, 82);
                  }
                });

                var firstVal = values[0];
                var firstImg = valueImgMap[firstVal] || '';

                selectsHtml += '<div class="hg-opts-swatch">';
                selectsHtml += '<button type="button" class="hg-opts-swatch__trigger">';
                if (firstImg) selectsHtml += '<img class="hg-opts-swatch__trigger-img" src="' + firstImg + '" alt="' + escAttr(firstVal) + '" width="96" height="64" loading="lazy">';
                selectsHtml += '<span class="hg-opts-swatch__trigger-label">' + escHtml(firstVal) + '</span>';
                selectsHtml += '<svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>';
                selectsHtml += '</button>';
                selectsHtml += '<ul class="hg-opts-swatch__list" role="listbox">';
                values.forEach(function (val, i) {
                  var img = valueImgMap[val] || '';
                  selectsHtml += '<li class="hg-opts-swatch__item' + (i === 0 ? ' hg-opts-swatch__item--selected' : '') + '" data-value="' + escAttr(val) + '" role="option" aria-selected="' + (i === 0) + '">';
                  if (img) selectsHtml += '<img src="' + img + '" alt="' + escAttr(val) + '">';
                  selectsHtml += '<span>' + escHtml(val) + '</span></li>';
                });
                selectsHtml += '</ul>';
                selectsHtml += hiddenSelect;
                selectsHtml += '</div>';

              } else {
                /* build pill buttons */
                selectsHtml += '<div class="hg-opts-pills">';
                values.forEach(function (val, i) {
                  selectsHtml += '<button type="button" class="hg-opts-pill-btn' + (i === 0 ? ' hg-opts-pill-btn--selected' : '') + '" data-value="' + escAttr(val) + '">' + escHtml(val) + '</button>';
                });
                selectsHtml += hiddenSelect;
                selectsHtml += '</div>';
              }

              selectsHtml += '</div>'; /* hg-opts-group */
            });

            var bodyHtml = '';
            if (initImgSrc) bodyHtml += '<img class="hg-opts-popup__img" id="hg-opts-img" src="' + initImgSrc + '" alt="' + escAttr(prod.title) + '" width="400" height="200" loading="lazy">';
            bodyHtml += '<div class="hg-opts-popup__selects">' + selectsHtml + '</div>';
            optsBody.innerHTML = bodyHtml;
            optsAdd.disabled = false;

            /* swatch toggle and item selection */
            optsBody.querySelectorAll('.hg-opts-swatch').forEach(function (swatch) {
              var trigger = swatch.querySelector('.hg-opts-swatch__trigger');
              var list    = swatch.querySelector('.hg-opts-swatch__list');
              var sel     = swatch.querySelector('.hg-opts-hidden-select');
              var trigImg = swatch.querySelector('.hg-opts-swatch__trigger-img');
              var trigLbl = swatch.querySelector('.hg-opts-swatch__trigger-label');

              trigger.addEventListener('click', function (e) {
                e.stopPropagation();
                swatch.classList.toggle('open');
              });

              list.querySelectorAll('.hg-opts-swatch__item').forEach(function (item) {
                item.addEventListener('click', function () {
                  var val = item.dataset.value;
                  /* update hidden select */
                  sel.value = val;
                  /* update trigger */
                  var itemImg = item.querySelector('img');
                  if (trigImg && itemImg) trigImg.src = itemImg.src;
                  trigLbl.textContent = val;
                  /* update selected state */
                  list.querySelectorAll('.hg-opts-swatch__item').forEach(function (li) {
                    li.classList.toggle('hg-opts-swatch__item--selected', li === item);
                    li.setAttribute('aria-selected', li === item);
                  });
                  swatch.classList.remove('open');
                  updateSwatchAvailability();
                  updatePillAvailability();
                  updateOptsImg();
                });
              });
            });

            /* pill selection */
            optsBody.querySelectorAll('.hg-opts-pills').forEach(function (pills) {
              var sel = pills.querySelector('.hg-opts-hidden-select');
              pills.querySelectorAll('.hg-opts-pill-btn').forEach(function (pill) {
                pill.addEventListener('click', function () {
                  if (pill.style.display === 'none') return;
                  pills.querySelectorAll('.hg-opts-pill-btn').forEach(function (p) {
                    p.classList.toggle('hg-opts-pill-btn--selected', p === pill);
                  });
                  sel.value = pill.dataset.value;
                  updatePillAvailability();
                  updateOptsImg();
                });
              });
            });

            /* close swatch lists on outside click */
            document.addEventListener('click', function closeSwatch() {
              optsBody.querySelectorAll('.hg-opts-swatch.open').forEach(function (s) { s.classList.remove('open'); });
            });

            updateSwatchAvailability();
            updatePillAvailability();
            optsOverlay.classList.add('open');
            optsPopup.classList.add('open');
            optsPopup.setAttribute('aria-hidden', 'false');
          });
        });

        if (optsClose) optsClose.onclick = closeOptsPopup;
        if (optsOverlay) optsOverlay.onclick = closeOptsPopup;

        if (optsAdd) {
          optsAdd.onclick = function () {
            var variant = getSelectedVariant();
            if (!variant) return;
            optsAdd.disabled = true;
            var fd = new FormData();
            fd.append('id', variant.id);
            fd.append('quantity', '1');
            addItem(fd)
              .then(fetchAndRender)
              .then(function () {
                optsAdd.disabled = false;
                closeOptsPopup();
                var bodyEl = document.querySelector('.hg-cart-drawer__body');
                if (bodyEl) bodyEl.scrollTo({ top: 0, behavior: 'smooth' });
                maybeUpdateCartPage();
              })
              .catch(function () { optsAdd.disabled = false; });
          };
        }

        /* carousel nav */
        var prev = recsEl.querySelector('.hg-recs-prev');
        var next = recsEl.querySelector('.hg-recs-next');

        function updateRecsArrows() {
          if (!prev || !next) return;
          prev.disabled = listEl.scrollLeft <= 0;
          next.disabled = listEl.scrollLeft + listEl.clientWidth >= listEl.scrollWidth - 1;
        }

        updateRecsArrows();
        listEl.addEventListener('scroll', updateRecsArrows);

        if (prev) prev.onclick = function () { listEl.scrollBy({ left: -210, behavior: 'smooth' }); };
        if (next) next.onclick = function () { listEl.scrollBy({ left: 210, behavior: 'smooth' }); };
      })
      .catch(function () { recsEl.style.display = 'none'; });
  }

  /* --- Update cart page grid if open --- */
  function maybeUpdateCartPage() {
    if (document.getElementById('main-cart-items') && typeof window.hgUpdateCart === 'function') {
      window.hgUpdateCart();
    }
  }

  /* --- Adding placeholder --- */
  function showAddingPlaceholder() {
    var el = document.getElementById('hg-cart-items');
    if (!el) return;

    /* Show footer/checkout/shipping in case cart was empty */
    var footerNote  = drawer.querySelector('.hg-cart-drawer__footer-note');
    var checkoutWrap = drawer.querySelector('.hg-cart-drawer__checkout-wrap');
    var shippingBar = document.getElementById('hg-shipping-bar');
    var viewCart    = drawer.querySelector('.hg-cart-drawer__view-cart');
    if (footerNote)   footerNote.style.display   = '';
    if (checkoutWrap) checkoutWrap.style.display  = '';
    if (shippingBar)  shippingBar.style.display   = '';
    if (viewCart)     viewCart.style.display      = '';

    var placeholder =
      '<div class="hg-cart-item hg-cart-item--adding" id="hg-adding-placeholder">' +
        '<div class="hg-adding-placeholder__img"></div>' +
        '<div class="hg-cart-item__details">' +
          '<div class="hg-adding-placeholder__text">Adding to cart<span class="hg-adding-placeholder__dots"></span></div>' +
        '</div>' +
      '</div>';

    /* Remove empty-cart block if present, then prepend placeholder */
    var emptyEl = el.querySelector('.hg-cart-empty');
    if (emptyEl) {
      el.innerHTML = placeholder;
    } else {
      el.insertAdjacentHTML('afterbegin', placeholder);
    }
  }

  function hideAddingPlaceholder() {
    var ph = document.getElementById('hg-adding-placeholder');
    if (ph) ph.remove();
  }

  /* --- Cart icon shake --- */
  var shakeTimer = null;

  function shakeCartIcon() {
    var link = document.querySelector('a[aria-label="Cart"]') || document.getElementById('cart-icon-bubble');
    if (!link) return;
    var svg = link.querySelector('svg');
    if (!svg) return;
    svg.classList.remove('hg-cart-icon-shake');
    void svg.offsetWidth; /* force reflow to restart animation */
    svg.classList.add('hg-cart-icon-shake');
    svg.addEventListener('animationend', function () {
      svg.classList.remove('hg-cart-icon-shake');
    }, { once: true });
  }

  /* Shake twice after add-to-cart: immediately + once more after 7s */
  function triggerDoubleShake() {
    clearTimeout(shakeTimer);
    shakeCartIcon();
    shakeTimer = setTimeout(shakeCartIcon, 7000);
  }

  /* --- Init --- */
  document.addEventListener('DOMContentLoaded', function () {
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    /* Shipping bars are US-only gated server-side via localization.country.iso_code
       (hg-shipping-bar here + hg-cp-shipping-bar on cart page). No client geo-gate:
       GeoIP ignored the market/?country override and wrongly hid the bar. */

    /* Pre-load recommendations on page load so they're ready when drawer opens */
    if (PRELOAD_PRODUCT_ID) loadRecs(PRELOAD_PRODUCT_ID);

    /* On cart page: refresh drawer + subtotal from live cart data (fixes €0 on first EUR load) */
    if (document.getElementById('main-cart-items')) {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        /* Update drawer prices */
        render(cart);
        /* Update page subtotal (Shopify Markets may render total=0 on first EUR visit) */
        var subEl = document.querySelector('.hg-cs-subtotal__value');
        if (subEl) subEl.textContent = formatMoney(cart.total_price);
      }).catch(function() {});
    }

    /* Sync drawer when cart data changes (non-cart pages; cart page has its own subscriber) */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (document.getElementById('main-cart-items')) return; /* cart page handles it */
        if (event.cartData) render(event.cartData);
      });
    }

    /* Event delegation for qty/remove — works for both Liquid pre-rendered and JS-rendered items */
    var itemsContainer = document.getElementById('hg-cart-items');
    var qtyDebounce = {};
    var lastKnownQty = {}; /* line → last server-confirmed quantity */
    if (itemsContainer) {
      itemsContainer.addEventListener('click', function (e) {
        var minus = e.target.closest('.hg-qty-minus');
        var plus  = e.target.closest('.hg-qty-plus');
        var rem   = e.target.closest('.hg-cart-item__remove');
        var wl    = e.target.closest('.hg-cart-item__wishlist');
        if (!minus && !plus && !rem && !wl) return;

        if (wl) {
          e.stopPropagation();
          wl.disabled = true;
          if (typeof window.wishlistAddItem === 'function') {
            window.wishlistAddItem({
              id: wl.dataset.productId,
              url: wl.dataset.productUrl,
              title: wl.dataset.productTitle,
              image: wl.dataset.productImage,
              price: wl.dataset.productPrice
            });
          }
          changeQty(+wl.dataset.line, 0)
            .then(render)
            .then(maybeUpdateCartPage)
            .then(function () { wl.disabled = false; });
          return;
        }

        var btn = minus || plus || rem;
        var line = +btn.dataset.line;
        var qtyEl = btn.parentNode.querySelector('.hg-qty-val');
        if (rem) {
          changeQty(line, 0).then(function (cart) {
            cart.items.forEach(function (it, i) { lastKnownQty[i + 1] = it.quantity; });
            return render(cart);
          }).then(maybeUpdateCartPage)
            .catch(function () { fetchCart().then(render); });
        } else {
          /* Source of truth for baseVal: pending.target → lastKnownQty → DOM span */
          var spanVal = +(qtyEl ? qtyEl.textContent : 1);
          var pending = qtyDebounce[line];
          var baseVal = pending ? pending.target
                      : (lastKnownQty[line] !== undefined ? lastKnownQty[line] : spanVal);
          var origVal = pending ? pending.origVal
                      : (lastKnownQty[line] !== undefined ? lastKnownQty[line] : spanVal);
          var newVal = plus ? baseVal + 1 : Math.max(0, baseVal - 1);
          if (qtyEl) qtyEl.textContent = newVal;
          if (pending) {
            pending.target = newVal;
            clearTimeout(pending.timer);
          } else {
            pending = qtyDebounce[line] = { target: newVal, origVal: origVal };
          }
          pending.timer = setTimeout(function () {
            var finalQty = pending.target;
            var revertTo = pending.origVal;
            delete qtyDebounce[line];
            /* Optimistically record what we're about to send — clicks arriving
               during fetch in-flight will use this as baseVal, not stale span */
            lastKnownQty[line] = finalQty;
            changeQty(line, finalQty).then(function (cart) {
              /* Update lastKnownQty from server response */
              cart.items.forEach(function (it, i) { lastKnownQty[i + 1] = it.quantity; });
              return render(cart);
            }).then(maybeUpdateCartPage)
              .catch(function () {
                /* On 429/422 — sync to REAL cart state, don't trust origVal */
                fetchCart().then(function (cart) {
                  cart.items.forEach(function (it, i) { lastKnownQty[i + 1] = it.quantity; });
                  var realItem = cart.items[line - 1];
                  if (qtyEl) qtyEl.textContent = realItem ? realItem.quantity : revertTo;
                  render(cart);
                }).catch(function () { if (qtyEl) qtyEl.textContent = revertTo; });
              });
          }, 700);
        }
      });
    }

    /* Intercept ALL a[href="/cart"] clicks except the "View cart" link inside drawer */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="/cart"]');
      if (!link || link.closest('#hg-cart-drawer')) return;
      e.preventDefault();
      open();
    }, true);

    /* "Add to cart" form submit → open drawer instantly, show placeholder, update in background */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.querySelector('.btnAddToCart')) return;
      e.preventDefault();
      e.stopPropagation();
      var fd = new FormData(form);
      showDrawer();           /* open immediately */
      showAddingPlaceholder(); /* reserve space with "Adding item to your cart..." */
      addItem(fd)
        .then(fetchAndRender)
        .then(function () { triggerDoubleShake(); maybeUpdateCartPage(); })
        .catch(function (err) { console.error('[hg-cart] add error:', err); });
    }, true);

    /* 26.10.2026 (Grant): автопереход на оформление после рецепта убран — корзина мелькала
       и пропадала, это выглядело как сбой. Корзину открывает сам rxapp (hgOpenDrawer);
       здесь только подсветка кнопки Checkout, список — наверх (текст-подтверждение убран 26.10).
       Правку рецепта (mode != add) не трогаем. */
    document.addEventListener('rxapp:cart:added', function (e) {
      var d = e.detail || {};
      if (d.mode && d.mode !== 'add') return;
      var btn = document.getElementById('hg-cart-checkout-btn');
      var body = drawer.querySelector('.hg-cart-drawer__body');
      /* 26.10.2026 (Owner): right after Rx lenses, nothing between the items and Checkout - rating hidden until the drawer closes */
      var rating = drawer.querySelector('.hg-cart-drawer__checkout-wrap .hgGr--cart');
      if (rating) rating.hidden = true;
      if (body) body.scrollTop = 0;
      if (btn) {
        btn.classList.remove('is-highlight');
        void btn.offsetWidth; /* перезапуск анимации при повторном добавлении */
        btn.classList.add('is-highlight');
      }
    });

    /* Order note popup */
    var noteOverlay = document.getElementById('hg-cart-note-overlay');
    var notePopup   = document.getElementById('hg-cart-note-popup');
    var noteTrigger = document.getElementById('hg-cart-note-trigger');
    var noteCloseBtn= document.getElementById('hg-cart-note-popup-close');
    var noteInput   = document.getElementById('hg-cart-note-input');
    var noteSaveBtn = document.getElementById('hg-cart-note-save-btn');

    function openNotePopup() {
      if (!notePopup) return;
      var headerEl = drawer.querySelector('.hg-cart-drawer__header');
      var topOffset = headerEl ? headerEl.offsetHeight : 0;
      if (noteOverlay) { noteOverlay.style.top = topOffset + 'px'; noteOverlay.classList.add('open'); }
      notePopup.style.top = topOffset + 'px';
      notePopup.classList.add('open');
      notePopup.setAttribute('aria-hidden', 'false');
    }
    function closeNotePopup() {
      if (!notePopup) return;
      notePopup.classList.remove('open');
      notePopup.setAttribute('aria-hidden', 'true');
      if (noteOverlay) noteOverlay.classList.remove('open');
    }

    if (noteTrigger) noteTrigger.addEventListener('click', openNotePopup);
    if (noteCloseBtn) noteCloseBtn.addEventListener('click', closeNotePopup);
    if (noteOverlay) noteOverlay.addEventListener('click', closeNotePopup);

    /* Existing note is pre-filled server-side ({{ cart.note }} in the snippet) —
       the old fetch('/cart.js') here cost one request on every page load. */

    if (noteSaveBtn && noteInput) {
      noteSaveBtn.addEventListener('click', function () {
        noteSaveBtn.disabled = true;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteInput.value })
        })
          .then(function () {
            noteSaveBtn.textContent = 'Saved!';
            setTimeout(function () {
              noteSaveBtn.textContent = 'Save';
              noteSaveBtn.disabled = false;
              closeNotePopup();
            }, 1200);
          })
          .catch(function () { noteSaveBtn.disabled = false; });
      });
    }

    /* close */
    var closeBtn = document.getElementById('hg-cart-close-btn');
    if (closeBtn) closeBtn.addEventListener('click', close);

    var overlay = document.getElementById('hg-cart-drawer-overlay');
    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });
  });


})();
